import React from 'react';
import Footer from '../../components/Footer/Footer';
import SimpleHeader from '../../components/Header/simpleHeader';
import './SessionExpired.scss';
import ButtonNew from '../../components/Button/Button';
import { useCookies } from 'react-cookie';
import inProgressIcon from '../../Assets/images/Activation/inProgress.svg';

type initialProps = {
    history: any;
};

const SessionExpired = (props: initialProps) => {
    const [cookie, setCookie, removeCookie] = useCookies(['astoundAccessToken']);

    // Remove cookie
    // removeCookie('valueName');
    console.log(cookie);
    setCookie('astoundAccessToken', '');
    const handleLogout = () => {
        localStorage.clear();
        props.history.push('/mobile-login');
        removeCookie('astoundAccessToken');
        window.location.href = `${process.env.REACT_APP_ASTOUND_SSO_LOGOUT_URL}`;
    };
    // const handleLogout = () => {
    //     // localStorage.clear();
    //     // props.history.push('/mobile-login');
    //     // removeCookie('astoundAccessToken');
    //     localStorage.clear();
    //         cookies.remove('astoundAccessToken');
    //     window.location.href = `${process.env.REACT_APP_ASTOUND_SSO_LOGOUT_URL}`;
    // };
    return (
        <div className="astoundUserPage">
            <SimpleHeader history={props.history} isHelp={true} />

            <div className="userStatus">
                <img src={inProgressIcon} />
                <div className="userStatusTitle">Your Session Has Expired!</div>
                <div className="userStatusSubtitle">
                    Please log in again.
                </div>

                <div className="backToHome">
                    <ButtonNew primary={true} onClick={handleLogout}>
                        OKAY
                    </ButtonNew>
                </div>
            </div>

            <Footer isFixed={true} />
        </div>
    );
};

export default SessionExpired;
